import { HTMLAttributes } from "react";

export default function Alpine(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9166 13.3358L47.2501 23.6239L36.9166 33.912L26.5835 23.6239L36.9166 13.3358Z"
        fill="#77C1D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0835 13.3358L32.5057 34.6643H11.8391L0.75 23.6239L11.0835 13.3358Z"
        fill="#2D3441"
      />
    </svg>
  )
}
